<script setup>
import NeedSidebar from "@/views/ecosystem/needs/need/NeedSidebar.vue";
import {useRoute} from "vue2-helpers/vue-router";
import {onMounted, provide, ref} from "vue";
import needsService from "@/services/ecosystem/needs.service";
import NeedStartupsTable from "@/views/ecosystem/needs/need/NeedStartupsTable.vue";

const route = useRoute();
const need = ref(null);

onMounted(() => {
    getInfo();
});

async function getInfo() {
    const {data} = await needsService.getInfo(route.params.id);

    need.value = data;
}

provide('need', need);
</script>

<template>
    <div v-if="need" class="dashboard-page">
        <NeedSidebar/>

        <main class="dashboard-page__main">
            <NeedStartupsTable/>

            <div class="dashboard-page__card need-admin__card--double">
                <div class="dashboard-page__card__inner">
                    <header class="dashboard-page__card__header">
                        <h3 class="dashboard-page__title dashboard-page__title--startups">All startups</h3>
                        <div class="ml-auto">
                            <input type="text" placeholder="Search for a category" class="dashboard-page__search">
                        </div>
                    </header>

                    <div class="dashboard-page__filter--scroll dashboard-page__filter--scroll--secondary">
                        <span class="filter-item filter-item--all">All Startups</span>
                        <span class="filter-item" title="14">Smart Packaging</span>
                        <span class="filter-item" title="8">Fintech</span>
                        <span class="filter-item" title="2">Healthcare</span>
                        <span class="filter-item" title="2">Crypto</span>
                    </div>

                    <div class="dashboard-page__table dashboard-page__table-flexible">
                        <table>
                            <tbody>
                                <tr>
                                    <td class="pl-0">
                                        <div class="dashboard-page__table__title">
                                            <div class="data-labels-set data-labels-set--lg">
                                                <span class="data-label data-label--lightning"></span>
                                            </div>
                                            <div>
                                                <h6 class="heading6"><a href="#">ByteNest</a></h6>
                                                <p>97% match</p>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="status-plate-wrapper">
                                            <span class="status-plate status-plate--unreviewed">Smart Packaging</span>
                                            <span class="status-plate status-plate--unreviewed">Artificial Intelligence</span>
                                        </div>
                                    </td>
                                    <td align="right" class="pr-0">
                                        <button class="button button--lg button-secondary">Submit Startup</button>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="pl-0">
                                        <div class="dashboard-page__table__title">
                                            <div class="data-labels-set data-labels-set--lg">
                                                <span class="data-label data-label--lightning"></span>
                                            </div>
                                            <div>
                                                <h6 class="heading6"><a href="#">ByteNest</a></h6>
                                                <p>97% match</p>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="status-plate-wrapper">
                                            <span class="status-plate status-plate--unreviewed">Smart Packaging</span>
                                            <span class="status-plate status-plate--unreviewed">Artificial Intelligence</span>
                                        </div>
                                    </td>
                                    <td align="right" class="pr-0">
                                        <button class="button button--lg button-primary">Submit Startup</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <footer class="dashboard-page__card__footer">
                        <a href="#" class="link">Show More Startups</a>
                    </footer>
                </div>
            </div>
        </main>
    </div>
</template>

<style scoped>

</style>
